import React, { Component } from 'react';
import HoverPopover, {
	POSITION,
	PopoverContent,
} from '@react_components/hover_popover';
import SvgInfo from '../../others/svg_dist/Info';
import styled from 'styled-components';

const FormInputWrapper = styled.div<{
	margin: string;
	minWidth: string;
	flex: number | string;
}>`
	flex: ${({ flex }) => flex};
	min-width: ${({ minWidth }) => minWidth};
	margin: ${({ margin }) => margin};
`;

const FormInputLabel = styled.label`
	font-size: 9px;
	margin-left: 16px;
	user-select: none;
	white-space: nowrap;
	color: #707070;
`;

const FormInputContainer = styled.div<{
	hasIcon: boolean;
	hasError: boolean;
	disabled?: boolean;
}>`
	border: 2px solid #dfdfdf;
	border-radius: 5px;
	overflow: hidden;
	height: 40px;
	background-color: #fff;
	margin-top: 2px;
	position: relative;
	${({ hasError }) =>
		hasError &&
		`
		border: 2px solid #c65984 !important;
	`}
	${({ disabled }) =>
		disabled &&
		`
		background-color: #e5e5e5;
	`}
	&:focus-within {
		border: 2px solid #ffb861;
	}
	svg {
		top: 50%;
		left: 12px;
		position: absolute;
		width: 30px;
		height: 30px;
		transform: translateY(-50%);
		fill: ${({ hasError }) => (hasError ? '#c65984' : '#555555')};
	}
	input {
		all: unset;
		height: 100%;
		width: 100%;
		font-size: 15px;
		padding-left: ${({ hasIcon }) => (hasIcon ? '52px' : '16px')};
	}
`;

export const InputError = styled.div`
	position: absolute;
	top: 50%;
	right: 5px;
	transform: translateY(-50%);
	width: 30px;
	height: 30px;
	background-color: #fff;
	svg {
		width: 30px;
		height: 30px;
		fill: #c65984;
		transform: unset;
		position: static;
	}
`;

type Props = {
	value: string;
	onChange: (value: string) => void;
	label: string | JSX.Element;
	placeholder: string;
	Icon?: JSX.Element;
	maxWidth?: string;
	margin?: string;
	flex?: number;
	error?: string;
	onBlur?: (value: string) => void;
	disabled?: boolean;
	maxLength?: number;
};

type State = {};

class FormInput extends Component<Props, State> {
	state = {};

	render() {
		return (
			<FormInputWrapper
				margin={this.props.margin || ''}
				minWidth={this.props.maxWidth || ''}
				flex={this.props.flex || 'unset'}
			>
				<FormInputLabel>{this.props.label}</FormInputLabel>
				<FormInputContainer
					hasError={!this.props.disabled && !!this.props.error}
					hasIcon={!!this.props.Icon}
					disabled={this.props.disabled}
				>
					{this.props.Icon && <div>{this.props.Icon}</div>}
					<input
						value={this.props.value}
						onChange={(e) => this.props.onChange(e.target.value)}
						placeholder={this.props.placeholder}
						onBlur={(e) =>
							this.props.onBlur &&
							this.props.onBlur(e.target.value)
						}
						disabled={this.props.disabled}
						maxLength={this.props.maxLength}
					/>
					{!this.props.disabled && this.props.error && (
						<InputError>
							<HoverPopover
								tooltipStyle={{ zIndex: '999999' }}
								position={POSITION.TOP}
								content={
									<PopoverContent>
										{this.props.error}
									</PopoverContent>
								}
							>
								<SvgInfo />
							</HoverPopover>
						</InputError>
					)}
				</FormInputContainer>
			</FormInputWrapper>
		);
	}
}

export default FormInput;
